import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as csvImportApi from '../api/csv-import';
import type { CsvImportRequest, CsvImportResult } from '../api/csv-import';

/**
 * Run a CSV import. On success, invalidates queries scoped to the imported
 * entity so freshly created rows appear in the list immediately.
 */
export function useCsvImport() {
  const queryClient = useQueryClient();
  return useMutation<CsvImportResult, Error, CsvImportRequest>({
    mutationFn: (req) => csvImportApi.runCsvImport(req),
    onSuccess: (_data, variables) => {
      // Use the entity name as the cache key root: 'guest' → ['guests', ...].
      queryClient.invalidateQueries({ queryKey: [`${variables.entity}s`] });
    },
  });
}
